import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, Typography } from '@mui/material';
import { formatMoney } from './formatUtils';
var AWARD_INFO = appStrings.modules.nugget.scholarship.AWARD_INFO;
export function NuggetScholarshipSmall(_a) {
    var variant = _a.variant, _b = _a.contentSize, contentSize = _b === void 0 ? 'LARGE' : _b;
    var awardRangeMin = formatMoney(variant.awardMoneyRangeMin);
    var awardRangeMax = variant.awardMoneyRangeMax
        ? " - ".concat(formatMoney(variant.awardMoneyRangeMax))
        : '';
    var titleStyles = contentSize === 'SMALL' ? smallTextStyle : textStyle;
    return (_jsxs(Box, { my: 2, children: [(awardRangeMin || awardRangeMax) && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: AWARD_INFO.AWARD_RANGE }), " ", awardRangeMin, awardRangeMax] })), variant.awardType && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: AWARD_INFO.AWARD_TYPE }), " ", variant.awardType] })), variant.awardCategory && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: AWARD_INFO.AWARD_CATEGORY }), " ", variant.awardCategory] })), variant.awardDeadline && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: AWARD_INFO.APPLICATION_DEADLINE }), " ", variant.awardDeadline] }))] }));
}
export var textStyle = {
    fontFamily: 'Sarabun',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '20px',
    mt: 1,
};
export var smallTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '18px',
    mt: 0.5,
};
